export default __webpack_public_path__ + "static/media/booking.dea6e116.svg";